import React, { useState } from 'react';
import axios from 'axios';

const ImageUpload = ({ onDetect }) => {
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleImageChange = (event) => {
        const selectedImage = event.target.files[0];
        setImage(selectedImage);

        // Create a preview of the uploaded image
        const previewUrl = URL.createObjectURL(selectedImage);
        setImagePreview(previewUrl);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!image) return;

        const formData = new FormData();
        formData.append('images', image); // Adjust this based on the API requirements

        // Optional: Include latitude and longitude if you have them
        // formData.append('latitude', 12.9716);
        // formData.append('longitude', 77.5946);

        setLoading(true);
        setError('');

        try {
            const response = await axios.post('https://crop.kindwise.com/api/v1/identification', formData, {
                headers: {
                    'Api-Key': 'd7KhnlJiwoKAcxNUIF9JQh4JWKLfvA1rPAKqqj8gbFPZxiZQsk', // Replace with your actual API key
                    'Content-Type': 'multipart/form-data',
                },
            });
            onDetect(response.data); // Pass the response data to the parent component
        } catch (error) {
            console.error('Error detecting disease:', error);
            setError('Failed to detect the plant disease. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2>Upload Plant Image</h2>
            <form onSubmit={handleSubmit}>
                <input type="file" onChange={handleImageChange} accept="image/*" required />
                <button type="submit" disabled={loading}>
                    {loading ? 'Detecting...' : 'Detect Disease'}
                </button>
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </form>

            {imagePreview && (
                <div style={{ marginTop: '20px' }}>
                    <h3>Image Preview:</h3>
                    <img src={imagePreview} alt="Uploaded" style={{ maxWidth: '300px', maxHeight: '300px', borderRadius: '8px' }} />
                </div>
            )}
        </div>
    );
};

export default ImageUpload;
